const convertSnakeToCamelCase = s =>
  s.toLowerCase().replace(/([-_][a-z])/gi, $1 =>
    $1
      .toUpperCase()
      .replace('-', '')
      .replace('_', '')
  );

export default convertSnakeToCamelCase;
